'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
    useEffect(() => {
        const key = process.env.NEXT_PUBLIC_POSTHOG_KEY
        if (!key) return

        posthog.init(key, {
            // Route through our own domain to bypass ad blockers & Safari ITP
            api_host: '/ingest',
            ui_host: 'https://us.posthog.com', // keep the toolbar working
            person_profiles: 'identified_only',
            capture_pageview: true,
            capture_pageleave: true,
            // Error tracking
            capture_exceptions: true,
            // Session recording
            disable_session_recording: false,
            session_recording: {
                maskAllInputs: false,
            },
            // Prevent PostHog from intercepting RPC/WC fetch calls (causes CORS errors in Safari)
            capture_performance: {
                network_timing: false,
            },
        })
    }, [])

    if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
        return <>{children}</>
    }

    return <PHProvider client={posthog}>{children}</PHProvider>
}
